import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaUserShield } from "react-icons/fa";
import StaffRoleModal from "../Setting/StaffRole/AddUpdateStaffRoleModal";
import AddUpdateServiceModal from "../Setting/Services/AddUpdateServiceModal";
import AddUpdateClientIndustryModal from "../Setting/ClientIndustry/AddUpdateClientIndustryModal";
import AddUpdateStatusTypeModal from "../Setting/StatusType/AddUpdateStatusTypeModal";
import AddUpdateClientGroupingModal from "../Setting/ClientGrouping/AddUpdateClientGroupingModal";
import AddUpdateLeaveTypeModal from "../Setting/LeaveType/AddUpdateLeaveTypeModal";
import Android12Switch from "../../components/common/AndroidSwitch";
import ConfirmationModal from "../../components/common/ConfirmationModal";
import SuccessModal from "../../components/common/SuccessModal";
import { FaFileExport, FaFilter } from "react-icons/fa";
import { FaClipboardCheck } from "react-icons/fa";
import { FaEye } from "react-icons/fa";

import {
  ChangeRoleTypeStatus,
  DeleteRoleType,
  GetRoleTypeList,
} from "../../services/UserRole/UserRoleApi";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import ErrorModal from "../../components/common/ErrorModal";
import PaginationComponent from "../../components/common/PaginationModal";
import {
  ChangeClientIndustryStatus,
  DeleteClientIndustry,
  GetClientIndustryList,
} from "../../services/ClientIndustry/ClientIndustryApi";
import {
  ChangeClientGroupStatus,
  DeleteClientGroup,
  GetClientGroupList,
} from "../../services/ClientGrouping/ClientGroupingApi";
import {
  ChangeLeaveTypeStatus,
  DeleteLeaveType,
  GetLeaveTypeList,
} from "../../services/LeaveType/LeaveTypeApi";
import AddupdateStaffModal from "./../Setting/Admin/AddupdateStaffModal";
import Pagination from "../../components/common/PaginationModal";
import AddUpdateContactPersonRoleModal from "./../Setting/ContactPersonRole/AddUpdateContactPersonRoleModal";
import AddUpdateKRAModal from "./../Setting/KRA/AddUpdateKRAModal";
import {
  ChangeCustomerIndustryStatus,
  DeleteCustomerIndustry,
  GetCustomerIndustryList,
} from "../../services/CustomerIndustry/CustomerIndustryApi";
import AddUpdateCustomerIndustryModal from "./CustomerIndustry/AddUpdateCustomerIndustryModal";
import {
  ChangeCountryStatus,
  DeleteCountry,
  GetCountryList,
} from "../../services/Country/CountryApi";
import AddUpdateCountryModal from "./Country/AddUpdateCountryModal";
import {
  ChangeAdminStatus,
  DeleteAdmin,
  GetAdminList,
} from "../../services/Admin/AdminApi";
import NoResultFoundModel from "../../components/common/NoDataFound";
import AddUpdateuserAdminRoleModal from "./UserAdminRole/AddUpdateuserAdminRoleModal";
import AddUpdateSettingDesignationModal from "./SettingDesignation/AddUpdateSettingDesignationModal";
import {
  ChangeAdminRoleStatus,
  DeleteAdminRole,
  GetAdminRoleList,
} from "../../services/UserAdminRole/UserAdminRoleApi";
import {
  ChangeSADesignationStatus,
  DeleteSADesignation,
  GetSADesignationList,
} from "../../services/SettingDesignation/SettingDesignationApi";
import { GetQueryList } from "../../services/CustomerQuaries/CUstomerQuariesApi";
import SolveQueryModal from "./../../components/common/SolveQueryModal";
import ViewDetailsquaryModal from "./../../components/common/ViewDetailsquaryModal";

const tabs = [
  { id: 1, label: "Customer Industry" },

  { id: 2, label: "Country" },
  { id: 3, label: "Admin" },
  { id: 4, label: "Customer Quaries" },
  { id: 5, label: "Admin Role" },
  { id: 6, label: "Designation" },

  // { id: 4, label: "Statuses" },
  // { id: 2, label: "Checklist" },
];

function SettingList() {
  const navigate = useNavigate();

  const RoleTypeModuleName = "Predefined";

  const [activeTab, setActiveTab] = useState(() => {
    const storedTab = Number(localStorage.getItem("selectedTab"));
    const storedPath = localStorage.getItem("CurrentPath");
    return storedPath === "/setting" && storedTab ? storedTab : 1;
  });
  const [errorMessage, setErrorMessage] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize } = useContext(AuthContext);
  //user role Type variables
  const [CustomerIndustrySearch, setCustomerIndustrySearch] = useState("");
  const [CustomerIndustryList, setCustomerIndustryList] = useState([]);
  const [CustomerIndustryListCount, setCustomerIndustryListCount] = useState(0);
  const [CustomerIndustryCurrentPage, setCustomerIndustryCurrentPage] =
    useState(1);
  const [isCustomerIndustryModalOpen, setStaffRoleModalOpen] = useState(false);
  const [openAccessModel, setOpenAccessModel] = useState(false);

  //Admin Role
  const [UserAdminRoleSearch, setUserAdminRoleSearch] = useState("");
  const [UserAdminRoleList, setUserAdminRoleList] = useState([]);
  const [UserAdminRoleListCount, setUserAdminRoleListCount] = useState(0);
  const [UserAdminRoleCurrentPage, setUserAdminRoleCurrentPage] = useState(1);
  const [isUserAdminRoleModalOpen, setUserAdminRoleModalOpen] = useState(false);

  //Designation
  const [DesignationSearch, setDesignationSearch] = useState("");
  const [DesignationList, setDesignationList] = useState([]);
  const [DesignationListCount, setDesignationListCount] = useState(0);
  const [DesignationCurrentPage, setDesignationCurrentPage] = useState(1);
  const [isDesignationModalOpen, setDesignationModalOpen] = useState(false);
  //Country
  const [CountrySearch, setCountrySearch] = useState("");
  const [CountryList, setCountryList] = useState([]);
  const [CountryListCount, setCountryListCount] = useState(0);
  const [CountryCurrentPage, setCountryCurrentPage] = useState(1);
  const [isCountryModalOpen, setClientIndustryModalOpen] = useState(false);
  //Admin
  const [AdminSearch, setAdminSearch] = useState("");
  const [AdminList, setAdminList] = useState([]);
  const [AdminListCount, setAdminListCount] = useState(0);
  const [AdminCurrentPage, setAdminCurrentPage] = useState(1);
  const [isAdminOpen, setGroupingModalOpen] = useState(false);

  //Customer Quaries
  const [quariesTypeSearch, setquariesTypeSearch] = useState("");
  const [LeaveTypeList, setLeaveTypeList] = useState([]);
  const [LeaveTypeListCount, setLeaveTypeListCount] = useState(0);
  const [quariesTypeCurrentPage, setquariesTypeCurrentPage] = useState(1);
  const [isLeaveTypeOpen, setLeaveTypeModalOpen] = useState(false);
  const [queryList, setQueryList] = useState([]);
  const [queryTypeListCount, setQueryTypeListCount] = useState(-1);
  const [isCompletedQueries, setIsCompletedQueries] = useState(false);
  const handleCloseSolveQuaryModal = () => setSolveQuaryModalOpen(false);
  const handleCloseViewQuaryModal = () => setViewQuaryModalOpen(false);

  const [isServiceModalOpen, setServiceModalOpen] = useState(false);
  const [OpenStatusAddModel, setOpenStatusAddModel] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    KeyID: null,
    Action: null,
    status: null,
    Name: null,
    remark: null,
  });

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
    if (tab === 1) {
      GetCustomerIndustryListData(1);
    } else if (tab === 2) {
      GetCountryListData(1);
    } else if (tab === 3) {
      GetAdminListData(1);
    } else if (tab === 4) {
      setActiveSubTab("pendingQueries"); // Set default sub-tab to pending
      GetQueryListData(1); // Fetch data for Customer Queries when tab 4 is active
    } else if (tab === 5) {
      GetAdminRoleListData(1);
    } else if (tab === 6) {
      GetSADesignationListData(1);
    }
  };
  //initial UseEffect
  useEffect(() => {
    if (activeTab === 1) {
      GetCustomerIndustryListData(1);
    } else if (activeTab === 2) {
      GetCountryListData(1);
    } else if (activeTab === 3) {
      GetAdminListData(1);
    } else if (activeTab === 4) {
      GetQueryListData(1);
    } else if (activeTab === 5) {
      GetAdminRoleListData(1);
    } else if (activeTab === 6) {
      GetSADesignationListData(1);
    }
  }, []);

  useEffect(() => {
    if (isAddUpdateDone) {
      if (activeTab === 1) {
        setCustomerIndustrySearch("");
        GetCustomerIndustryListData(CustomerIndustryCurrentPage, null);
      } else if (activeTab === 2) {
        setCountrySearch("");
        GetCountryListData(CountryCurrentPage, null);
      } else if (activeTab === 3) {
        setAdminSearch("");
        GetAdminListData(AdminCurrentPage, null);
      } else if (activeTab === 4) {
        GetQueryListData(quariesTypeCurrentPage, null, false); // Default to pending queries
        setIsCompletedQueries(false); // Set to false for pending queries
      } else if (activeTab === 5) {
        setUserAdminRoleSearch("");
        GetAdminRoleListData(UserAdminRoleCurrentPage, null);
      } else if (activeTab === 6) {
        setDesignationSearch("");
        GetSADesignationListData(DesignationCurrentPage, null);
      }
      setIsAddUpdateDone(false);
    }
  }, [isAddUpdateDone]);

  //User Role Type Search
  const handleSearchFunction = (searchValue) => {
    if (activeTab === 1) {
      setCustomerIndustrySearch(searchValue);
      GetCustomerIndustryListData(1, searchValue);
    } else if (activeTab === 2) {
      setCountrySearch(searchValue);
      GetCountryListData(1, searchValue);
    } else if (activeTab === 3) {
      setAdminSearch(searchValue);
      GetAdminListData(1, searchValue);
    } else if (activeTab === 4) {
      setquariesTypeSearch(searchValue);
      GetQueryListData(1, searchValue);
    } else if (activeTab === 5) {
      setUserAdminRoleSearch(searchValue);
      GetAdminRoleListData(1, searchValue);
    } else if (activeTab === 6) {
      setDesignationSearch(searchValue);
      GetSADesignationListData(1, searchValue);
    }
  };

  //tab Save UseEffect
  useEffect(() => {
    localStorage.setItem("selectedTab", activeTab);
    localStorage.setItem("CurrentPath", "/setting");
  }, [activeTab]);

  //User Role List Api
  const GetCustomerIndustryListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetCustomerIndustryList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? CustomerIndustrySearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setCustomerIndustryListCount(response.totalCount);
        setCustomerIndustryList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Country Api
  const GetCountryListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetCountryList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? CountrySearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setCountryListCount(response.totalCount);
        setCountryList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Admin Api
  const GetAdminListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetAdminList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? AdminSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setAdminListCount(response.totalCount);
        setAdminList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Admin Role
  const GetAdminRoleListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetAdminRoleList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? UserAdminRoleSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setUserAdminRoleListCount(response.totalCount);
        setUserAdminRoleList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Designation

  const GetSADesignationListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetSADesignationList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? DesignationSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setDesignationListCount(response.totalCount);
        setDesignationList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Customer Quaries Api
  const GetQueryListData = async (i, searchKeyword, isCompleted) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetQueryList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? quariesTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
        IsCompleted: isCompleted ? "True" : "False", // Pass the IsCompleted parameter
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setQueryList(list); // Update state with fetched data
        setQueryTypeListCount(response.totalCount);
      } else {
        setLoader(false);
        // Handle error response
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      // Optionally show an error message to the user
    }
  };

  //handle Functions
  const handleOpenStaffRoleModal = () => setStaffRoleModalOpen(true);
  const handleCloseCustomerIndustryModal = () => setStaffRoleModalOpen(false);
  const handleOpenServiceModal = () => setServiceModalOpen(true);
  const handleCloseServiceModal = () => setServiceModalOpen(false);
  const handleOpenClientIndustryModal = () => setClientIndustryModalOpen(true);
  const handleCloseCountryModal = () => setClientIndustryModalOpen(false);
  const handleOpenGroupingModal = () => setGroupingModalOpen(true);
  const handleCloseAdminModal = () => setGroupingModalOpen(false);
  const handleOpenLeaveTypeModal = () => setLeaveTypeModalOpen(true);
  const handleCloseLeaveTypeModal = () => setLeaveTypeModalOpen(false);
  const handleCloseUserAdminRoleModal = () => setUserAdminRoleModalOpen(false);
  const handleOpenUserAdminRoleModal = () => setUserAdminRoleModalOpen(true);

  const handleCloseDesignationModal = () => setDesignationModalOpen(false);
  const handleOpenDesignationModal = () => setDesignationModalOpen(true);

  const handleActionButton = async () => {
    setLoader(true);
    if (modelAction === "Delete") {
      let data;
      try {
        if (activeTab === 1) {
          data = await DeleteCustomerIndustry(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 2) {
          data = await DeleteCountry(
            // RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 3) {
          data = await DeleteAdmin(
            // RoleTypeModuleName,
            modelRequestData.KeyID
            // authDetails.adminKeyID
          );
        } else if (activeTab === 4) {
          data = await DeleteLeaveType(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 5) {
          data = await DeleteAdminRole(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 6) {
          data = await DeleteSADesignation(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        }
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setConfirmationModal(false);
          setIsErrorOpen(true);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    } else if (modelAction === "Status") {
      try {
        let data;
        if (activeTab === 1) {
          data = await ChangeCustomerIndustryStatus(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 2) {
          data = await ChangeCountryStatus(
            // RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 3) {
          data = await ChangeAdminStatus(
            // RoleTypeModuleName,
            modelRequestData.KeyID
            // authDetails.adminKeyID
          );
        } else if (activeTab === 4) {
          data = await ChangeLeaveTypeStatus(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 5) {
          data = await ChangeAdminRoleStatus(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === 6) {
          data = await ChangeSADesignationStatus(
            RoleTypeModuleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        }
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setIsErrorOpen(true);
          setConfirmationModal(false);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    }
  };

  const HandlePageChange = async (pageNumber) => {
    if (activeTab === 1) {
      setCustomerIndustryCurrentPage(pageNumber);
      await GetCustomerIndustryListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === 2) {
      setCountryCurrentPage(pageNumber);
      await GetCountryListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === 3) {
      setAdminCurrentPage(pageNumber);
      await GetAdminListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === 4) {
      setquariesTypeCurrentPage(pageNumber);
      await GetQueryListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === 5) {
      setUserAdminRoleCurrentPage(pageNumber);
      await GetAdminRoleListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === 6) {
      setDesignationCurrentPage(pageNumber);
      await GetSADesignationListData(pageNumber); // Call your function with the selected page number
    }
  };

  //demo
  const [activeSubTab, setActiveSubTab] = useState("pendingQueries");
  const handleOpenSolveQuaryModal = () => setSolveQuaryModalOpen(true);
  const [isSolvequary, setSolveQuaryModalOpen] = useState(false);
  const [isViewquary, setViewQuaryModalOpen] = useState(false);

  const [isContactPersonRoleModalOpen, setContactPersonRoleModalOpen] =
    useState(false);
  const [isStatusTypeModalOpen, setStatusTypeModalOpen] = useState(false);
  const [isKRAModalOpen, setKRAModalOpen] = useState(false);

  const handleOpenContactPersonRoleModal = () =>
    setContactPersonRoleModalOpen(true);

  const handleCloseContactPersonRoleModal = () =>
    setContactPersonRoleModalOpen(false);

  const handleOpenStatusTypeModal = () => setStatusTypeModalOpen(true);
  const handleCloseStatusTypeModal = () => setStatusTypeModalOpen(false);

  const handleOpenKRAModal = () => setKRAModalOpen(true);
  const handleOpenViewQuaryModal = () => setViewQuaryModalOpen(true);

  const handleCloseKRAModal = () => setKRAModalOpen(false);

  const handleOpenPendingQueries = () => {
    setActiveSubTab("pendingQueries");
    GetQueryListData(1, null, false); // Fetch pending queries
    setIsCompletedQueries(false);
  };

  const handleOpenCompletedQueries = () => {
    setActiveSubTab("completedQueries");
    GetQueryListData(1, null, true); // Fetch completed queries
    setIsCompletedQueries(true);
  };
  return (
    <>
      <div className="bg-gray-50 mx-auto mb-10">
        <div className="bg-white shadow-lg rounded-lg px-6">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 15px",
            }}
            className="p-4 overflow-x-auto"
          >
            <>
              <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 border-b text-12">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`px-4 py-2 whitespace-nowrap border-b-2 ${
                      activeTab === tab.id
                        ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                        : "border-transparent text-gray-900"
                    }`}
                    onClick={() => {
                      handleChangeTab(tab.id);
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </>
          </div>

          {/* Tab Content */}
          {/* User Role */}
          {activeTab === 1 && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Customer Industry"
                            value={CustomerIndustrySearch}
                            onChange={(e) => {
                              handleSearchFunction(
                                e.target.value,
                                RoleTypeModuleName
                              );
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Customer Industry">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenStaffRoleModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Customer Industry
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Customer Industry
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {CustomerIndustryList?.map((role, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left p-1">
                                  {role.customerIndustryName}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {role.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>

                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={role.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: role.customerIndustryKeyID,
                                            status:
                                              role.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Customer Industry">
                                      <button
                                        className="text-[#135EA0] hover:text-[#135EA0]"
                                        onClick={() => {
                                          setModelRequestData({
                                            KeyID: role.customerIndustryKeyID,
                                            Action: "Update",
                                          });
                                          handleOpenStaffRoleModal();
                                        }}
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Customer Industry">
                                      <button
                                        className="text-gray-400 hover:text-gray-400"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: role.customerIndustryName,
                                            KeyID: role.customerIndustryKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {CustomerIndustryListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={CustomerIndustryListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {CustomerIndustryListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            CustomerIndustryListCount / pageSize
                          )}
                          currentPage={CustomerIndustryCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}

          {/* Country Tab */}
          {activeTab === 2 && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Country"
                            value={CountrySearch}
                            onChange={(e) => {
                              handleSearchFunction(
                                e.target.value,
                                RoleTypeModuleName
                              );
                            }}
                          />
                        </div>

                        {/* Add Country Button */}
                        <Tooltip title="Add Country">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                                status: null,
                              });
                              handleOpenClientIndustryModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Country
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Country
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Country Code
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Country Name
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Currency
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Currency Status
                              </th>

                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {CountryList.map((industry, index) => (
                              <tr
                                key={industry.countryKeyID}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {industry.countryCode}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {industry.countryName}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {industry.currencySymbol}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {industry.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={industry.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: industry.countryKeyID,
                                            status:
                                              industry.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Country">
                                      <button className="text-[#135EA0] hover:text-[#135EA0]">
                                        <FaEdit
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              KeyID: industry.countryKeyID,
                                              Action: "Update",
                                              status: null,
                                            });
                                            handleOpenClientIndustryModal();
                                          }}
                                          className="text-12"
                                        />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Country">
                                      <button className="text-gray-400 hover:text-gray-400">
                                        <FaTrash
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              Name: industry.countryName,
                                              KeyID: industry.countryKeyID,
                                              status: null,
                                            });
                                            setModelAction("Delete");
                                            setConfirmationModal(true);
                                          }}
                                          className="text-12"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {CountryListCount <= 0 && (
                          <NoResultFoundModel totalRecords={CountryListCount} />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {CountryListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(CountryListCount / pageSize)}
                          currentPage={CountryCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>{" "}
            </div>
          )}

          {/* Admin*/}
          {activeTab === 3 && (
            <div>
              <>
                <div className="bg-gray-50 mx-auto rep-width">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}

                    <div className="p-2 border-b flex flex-wrap items-center justify-between">
                      {/* Search Bar and Add Button Wrapper (Always Aligned to End of Row) */}
                      <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full sm:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Admin"
                            value={AdminSearch}
                            onChange={(e) => {
                              handleSearchFunction(
                                e.target.value,
                                RoleTypeModuleName
                              );
                            }}
                          />
                        </div>

                        {/* Add KRA Button */}
                        <Tooltip title="Add Admin">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                                status: null,
                              });
                              handleOpenGroupingModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                          >
                            + Add Admin
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 text-12 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0]`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Admin{" "}
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper border border-gray-200">
                      <div className="flex-1 overflow-y-auto">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 bg-white z-10">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                First Name
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Last Name
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Email
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Phone
                              </th>

                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Status
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {AdminList.map((admin) => (
                              <tr
                                key={admin.adminKeyID}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {admin.firstName}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {admin.lastName}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {admin.email}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {admin.mobileNo}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {admin.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={admin.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: admin.adminKeyID,
                                            status:
                                              admin.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>
                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Admin">
                                      <button
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: admin.adminKeyID,
                                            Action: "Update",
                                            status: null,
                                          });
                                          handleOpenGroupingModal();
                                        }}
                                        className="text-[#135EA0]"
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>

                                    <Tooltip title="Delete Admin">
                                      <button
                                        className="text-gray-500"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: admin.firstName,
                                            KeyID: admin.adminKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {AdminListCount <= 0 && (
                          <NoResultFoundModel totalRecords={AdminListCount} />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {AdminListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(AdminListCount / pageSize)}
                          currentPage={AdminCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>{" "}
            </div>
          )}
          {/* Customer Quaries */}
          {activeTab === 4 && (
            <div>
              <div className="flex border-b border-gray-300 pb-2">
                <button
                  onClick={handleOpenPendingQueries}
                  className={`px-3 py-2 text-xs font-small transition-all whitespace-nowrap ${
                    activeSubTab === "pendingQueries"
                      ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                >
                  Pending
                </button>
                <button
                  onClick={handleOpenCompletedQueries}
                  className={`px-3 py-2 text-xs font-small transition-all whitespace-nowrap ${
                    activeSubTab === "completedQueries"
                      ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                >
                  Completed
                </button>
              </div>

              {/* Search, Filter, and Export Section */}
              <div className="h-full bg-white shadow rounded-lg flex flex-col">
                <div className="p-2 border-b flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4">
                  {/* Search Bar and Buttons Wrapper */}
                  <div className="flex flex-wrap items-center gap-2 md:gap-4 ml-auto w-full md:w-auto justify-end">
                    {/* Export Button */}

                    {/* Filter Button */}
                    {/* <button className="flex items-center text-[#135EA0] hover:text-[#E86B1B] text-12">
                      <FaFilter className="mr-1" />
                      Filter
                    </button> */}

                    {/* Search Bar */}
                    <div className="relative flex items-center w-full md:w-64">
                      <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                      <input
                        type="text"
                        className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                        placeholder="Search..."
                        value={quariesTypeSearch}
                        onChange={(e) => {
                          handleSearchFunction(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Sub-Tab Content */}
              {activeSubTab === "pendingQueries" && (
                <div className="flex-1 overflow-y-auto">
                  <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                    <thead>
                      <tr className="z-1 sticky top-0 bg-white">
                        <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                          Customer Name
                        </th>
                        <th className="p-2 border-b border-slate-200 text-left">
                          Query
                        </th>
                        <th className="p-2 border-b border-slate-200 text-left">
                          Received Date
                        </th>
                        <th className="p-2 border-b border-slate-200 text-right">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {queryList
                        .filter((query) => !query.completedOnDate) // Filter for pending queries
                        .map((query) => (
                          <tr
                            key={query.queryKeyID}
                            className="hover:bg-slate-50 border-b border-slate-200"
                          >
                            <td className="p-2">{query.createdByName}</td>
                            <td className="p-2">{query.query}</td>
                            <td className="p-2">
                              {new Date(
                                query.createdOnDate
                              ).toLocaleDateString()}
                            </td>
                            <td className="whitespace-nowrap text-left p-1">
                              <div className="flex justify-end gap-2">
                                <Tooltip title="Solve Query" arrow>
                                  <button
                                    onClick={() => {
                                      setModelRequestData({
                                        KeyID: query.queryKeyID,
                                        Action: "Update",
                                      });
                                      handleOpenSolveQuaryModal();
                                    }}
                                    className="text-[#135EA0] hover:text-[#135EA0]"
                                  >
                                    <FaClipboardCheck className="text-sm" />
                                  </button>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {queryTypeListCount <= 0 && (
                    <NoResultFoundModel totalRecords={queryTypeListCount} />
                  )}
                </div>
              )}

              {activeSubTab === "completedQueries" && (
                <div className="flex-1 overflow-y-auto">
                  <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                    <thead>
                      <tr className="z-1 sticky top-0 bg-white">
                        <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                          Customer Name
                        </th>
                        <th className="p-2 border-b border-slate-200 text-left">
                          Query
                        </th>
                        <th className="p-2 border-b border-slate-200 text-left">
                          Received Date
                        </th>
                        <th className="p-2 border-b border-slate-200 text-left">
                          Completed Date
                        </th>
                        <th className="p-2 border-b border-slate-200 text-right">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {queryList
                        .filter((query) => query.completedOnDate) // Filter for completed queries
                        .map((query) => (
                          <tr
                            key={query.queryKeyID}
                            className="hover:bg-slate-50 border-b border-slate-200"
                          >
                            <td className="p-2">{query.createdByName}</td>
                            <td className="p-2">{query.query}</td>
                            <td className="p-2">
                              {new Date(
                                query.createdOnDate
                              ).toLocaleDateString()}
                            </td>
                            <td className="p-2">
                              {query.completedOnDate
                                ? new Date(
                                    query.completedOnDate
                                  ).toLocaleDateString()
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap text-left p-1">
                              <div className="flex justify-end gap-2">
                                <Tooltip title="View Query Details" arrow>
                                  <button
                                    onClick={() => {
                                      setModelRequestData({
                                        KeyID: query.queryKeyID,
                                        Action: "Update",
                                        remark: query.remark,
                                      });
                                      handleOpenViewQuaryModal();
                                    }}
                                    className="text-[#135EA0] hover:text-[#135EA0]"
                                  >
                                    <FaEye className="text-sm" />
                                  </button>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {queryTypeListCount <= 0 && (
                    <NoResultFoundModel totalRecords={queryTypeListCount} />
                  )}
                </div>
              )}
              {queryTypeListCount > pageSize && (
                <div className="flex justify-end ">
                  <PaginationComponent
                    totalPages={Math.ceil(queryTypeListCount / pageSize)}
                    currentPage={quariesTypeCurrentPage}
                    onPageChange={HandlePageChange}
                  />
                </div>
              )}
            </div>
          )}
          {/* Admin Role*/}
          {activeTab === 5 && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Admin Role"
                            value={UserAdminRoleSearch}
                            onChange={(e) => {
                              handleSearchFunction(
                                e.target.value,
                                RoleTypeModuleName
                              );
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Admin Role">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenUserAdminRoleModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Admin Role
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Admin Role
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Admin Role Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {UserAdminRoleList?.map((role, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left p-1">
                                  {role.adminRoleName}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {role.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>

                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={role.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: role.adminRoleKeyID,
                                            status:
                                              role.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Admin Role">
                                      <button
                                        className="text-[#135EA0] hover:text-[#135EA0]"
                                        onClick={() => {
                                          setModelRequestData({
                                            KeyID: role.adminRoleKeyID,
                                            Action: "Update",
                                          });
                                          handleOpenUserAdminRoleModal();
                                        }}
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Admin Role">
                                      <button
                                        className="text-gray-400 hover:text-gray-400"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: role.adminRoleName,
                                            KeyID: role.adminRoleKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {UserAdminRoleListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={UserAdminRoleListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {UserAdminRoleListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            UserAdminRoleListCount / pageSize
                          )}
                          currentPage={UserAdminRoleCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}
          {/*Designation*/}
          {activeTab === 6 && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Designation"
                            value={DesignationSearch}
                            onChange={(e) => {
                              handleSearchFunction(
                                e.target.value,
                                RoleTypeModuleName
                              );
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Designation">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenDesignationModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Designation
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Designation
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Designation Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {DesignationList?.map((role, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left p-1">
                                  {role.designationName}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {role.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>

                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={role.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: role.designationKeyID,
                                            status:
                                              role.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Designation">
                                      <button
                                        className="text-[#135EA0] hover:text-[#135EA0]"
                                        onClick={() => {
                                          setModelRequestData({
                                            KeyID: role.designationKeyID,
                                            Action: "Update",
                                          });
                                          handleOpenDesignationModal();
                                        }}
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Designation">
                                      <button
                                        className="text-gray-400 hover:text-gray-400"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: role.designationName,
                                            KeyID: role.designationKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {DesignationListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={CustomerIndustryListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {DesignationListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            DesignationListCount / pageSize
                          )}
                          currentPage={DesignationCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
        <ErrorModal
          isOpen={isErrorOpen}
          onClose={() => setIsErrorOpen(false)}
          errorMessage={errorMessage}
        />

        {isCustomerIndustryModalOpen && (
          <AddUpdateCustomerIndustryModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isCustomerIndustryModalOpen}
            onClose={handleCloseCustomerIndustryModal}
          />
        )}

        {isUserAdminRoleModalOpen && (
          <AddUpdateuserAdminRoleModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isUserAdminRoleModalOpen}
            onClose={handleCloseUserAdminRoleModal}
          />
        )}
        {isDesignationModalOpen && (
          <AddUpdateSettingDesignationModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isDesignationModalOpen}
            onClose={handleCloseDesignationModal}
          />
        )}

        <AddUpdateContactPersonRoleModal
          isOpen={isContactPersonRoleModalOpen}
          onClose={handleCloseContactPersonRoleModal}
        />
        <AddUpdateStatusTypeModal
          isOpen={isStatusTypeModalOpen}
          onClose={handleCloseStatusTypeModal}
        />
        <AddUpdateKRAModal
          isOpen={isKRAModalOpen}
          onClose={handleCloseKRAModal}
        />

        <AddUpdateServiceModal
          isOpen={isServiceModalOpen}
          onClose={handleCloseServiceModal}
        />
        {isCountryModalOpen && (
          <AddUpdateCountryModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isCountryModalOpen}
            onClose={handleCloseCountryModal}
          />
        )}

        {isAdminOpen && (
          <AddupdateStaffModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isAdminOpen}
            onClose={handleCloseAdminModal}
          />
        )}
        {isLeaveTypeOpen && (
          <AddUpdateLeaveTypeModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isLeaveTypeOpen}
            onClose={handleCloseLeaveTypeModal}
          />
        )}

        <ConfirmationModal
          show={confirmationModal}
          onHide={() => setConfirmationModal(false)}
          actionType={modelAction}
          onConfirm={() => handleActionButton()}
          modelRequestData={modelRequestData}
        />

        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => setShowSuccessPopupModal(false)}
          modelAction={modelAction}
          actionMessage={
            modelAction === "Status"
              ? "Status has been changed successfully!"
              : modelRequestData.Name
          }
        />
        <SolveQueryModal
          isOpen={isSolvequary}
          onClose={handleCloseSolveQuaryModal}
          modelRequestData={modelRequestData}
          setIsAddUpdateDone={setIsAddUpdateDone}
        />
        <ViewDetailsquaryModal
          isOpen={isViewquary}
          onClose={handleCloseViewQuaryModal}
          modelRequestData={modelRequestData}
        />
      </div>
    </>
  );
}

export default SettingList;
